import { DesignObjectModel } from '../../model/design-object.model';
import { CustomListModel } from '../../model/custom-list.model';

export function isCustomListModel(design: DesignObjectModel): design is CustomListModel {
  return design instanceof CustomListModel;
}
